import useIsomorphicLayoutEffect from './use-isomorphic-layout-effect'
type Props = {
  title?: string
  link?: {
    href: string
    rel: string
  }
  style?: {
    type: string
    cssText: string | null | undefined
  }[]
}
export function useDocumentHeadTags({ title, style, link }: Props): void {
  useIsomorphicLayoutEffect(() => {
    if (title) {
      window.document.title = title
    }

    const addedStyleTags = []
    const addedLinkTags = []

    if (style && Array.isArray(style)) {
      style.forEach(s => {
        if (s.type && s.cssText) {
          const styleTag = document.createElement('style')
          styleTag.setAttribute('type', s.type)
          styleTag.textContent = s.cssText || ''

          if (document.head) {
            document.head.appendChild(styleTag)
            addedStyleTags.push(styleTag)
          }
        }
      })
    }

    if (link) {
      const linkTag = document.createElement('link')
      Object.entries(link).forEach(([key, value]) => {
        linkTag.setAttribute(key, String(value))
      })

      if (document.head) {
        document.head.appendChild(linkTag)
        addedLinkTags.push(linkTag)
      }
    }

    return () => {
      addedStyleTags.forEach(styleTag => {
        if (styleTag && document.head) {
          document.head.removeChild(styleTag)
        }
      })
      addedLinkTags.forEach(linkTag => {
        if (linkTag && document.head) {
          document.head.removeChild(linkTag)
        }
      })
    }
  }, [title, style, link])
}
